import { createSlice } from "@reduxjs/toolkit";


interface InitialStateInterface {
	loading: boolean;
	data:Record<string,any>
}

const initialState: InitialStateInterface = {
	loading: true,
	data: {},
	
};

const analyticSlice = createSlice({
	name: "analytic",
	initialState,
	reducers: {
		
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setData: (state, { payload }) => {
			state.data = payload;
		}
	},
});

export const {
	setLoading,
	setData
} = analyticSlice.actions;

export default analyticSlice.reducer;
